import { fetchRingV1ControllerGetRingsDetails } from 'generated/apiComponents';
import { ringSyncService } from 'technical/db/sync/ring-sync.service';
import { segmentSyncService } from 'technical/db/sync/segment-sync.service';

export const syncRingData = async (
  constructionSiteId: string,
  ringNumberStart: number,
  ringNumberEnd: number,
  headers: any,
) => {
  const response = await fetchRingV1ControllerGetRingsDetails({
    pathParams: {
      constructionSiteId,
    },
    queryParams: {
      startRing: ringNumberStart,
      endRing: ringNumberEnd,
    },
    headers,
  });

  const rings = response?.rings ?? [];
  if (rings.length > 0) {
    await ringSyncService.download(rings);
  }
  const promises = rings.map(async (ring) => {
    const segments = ring.segments.map((segment) => ({
      ...segment,
      ringId: ring.id,
    }));
    return segmentSyncService.download(segments);
  });
  await Promise.all(promises);
};
